import React from 'react';
import { Link } from 'react-router-dom';
import buildInfo from '../../../buildInfo.json';

// powered-by logo
import PoweredBy from '../../../assets/images/logo-footer.png';

const MainFooter = () => {
  const versionString = `v${buildInfo.version}.${buildInfo.build}`;

  return (
    <footer className='main-page-footer'>
      <div className='footer-left'>
        <img src={PoweredBy} alt='Powered by BeClutch' className='footer-powered-logo' />
      </div>
      <div className='footer-center'>
        <p>Copyright © 2025 beclutch.club</p>
        <p>All Rights Reserved</p>
      </div>
      <div className='footer-right'>
        <p>{versionString}</p>
      </div>
    </footer>
  );
};

export default MainFooter;
